import React, { useEffect, useState } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import {
    Grid,
    IconButton,
    InputAdornment,
    Button,
    makeStyles
} from "@material-ui/core";
import InfoDialog from '../Dialog/InfoDialog';
import ReportsDialog from '../ReportsDialog/ReportsDialog';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { numberFormat, getTripStartDateFilterValues } from '../../../utils/utils';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { PaperPlaneIconWhite } from '../../../components/icons';
import PaySupplierSideBar from '../RightSideBar/PaySupplierSideBar';
import SuccessDialog from '../Verfication/SuccessDialog';
import FailureDialog from '../Verfication/FailureDialog';
import { getPaymentStatus } from '../../../store/actions/OnlinePaymentActionCreators';
import { fetchSupplierTransactionLog } from '../../../store/actions/userActionCreators';
import { getSingleVendorLedgerData } from '../../../store/actions/homeActionCreator';
import { singleVendorDetails } from '../../../store/actions/vehicleActionCreator';
import queryString from "query-string";
import { TRIP_TRANSACTION_FILTER, TRIP_FILTER_STATUS_MAPPING } from '../../../store/constants';
import { trackDwebEvent } from '../../analytics';
import * as logger from '../../../logger';
import CardSelectionDialog from '../Dialog/CardSelectionDialog';
import PassBookReportDialog from '../ReportsDialog/PassBookReportDialog';
const useStyles = makeStyles(() => ({

    sparklineContainer: {
        padding: '12px 24px',
        borderRadius: '4px',
        border: 'solid 1px #eaedf3',
        display: 'flex'
    },
    sparklineTitle: {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.5,
        color: '#6b778c',
        textTransform: 'uppercase',
        letterSpacing: 'normal'
    },
    infoCardIcon: {
        fontSize: 14,
        margin: '-2px 3px 0px 3px',
        color: '#A8A8A8',
        //float: 'right',
        cursor: 'pointer'
        // marginTop: 4
    },
    loss: {
        fontSize: 24,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.83,
        letterSpacing: 'normal',
        color: '#ff0000',
        marginTop: 4,
        marginLeft: 16
    },
    gridButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 60
    },
    viewPDFCta: {
        backgroundColor: '#f27f36',
        borderRadius: 4,
        border: 0,
        color: 'white',
        height: 36,
        padding: '7px 16px 7px 12px',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#f27f36'
        },
        fontWeight: 'normal',
        minWidth: 128
    },
    divAlign: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    mlV3: {
        marginLeft: 8
    },
    mlV1: {
        marginLeft: 16
    },
    sendMoneyCta: {
        padding: '7px 16px 7px 12px',
        borderRadius: 4,
        backgroundColor: '#1976d2',
        '&:hover': {
            backgroundColor: '#1976d2'
        },
        color: 'white',
        fontSize: 14,
        textTransform: 'capitalize',
        borderRadius: 4,
        border: 0,
        fontWeight: 'normal',
        minWidth: 146
    },

}));

const SingleSupplierTopCard = ({ user, dispatchGetPaymentStatus, dispatchFetchSupplierTransact, dispatchGetSingleVendorLedger, dispatchGetSingleVendorDetails }) => {

    const [infoOpen, setInfoOpen] = React.useState(false);
    const [supplierPdfOpen, setSupplierPdfOpen] = useState(false);
    const [paySupplier, setPaySupplier] = useState(false);
    const [successCreation, setSuccessCreation] = useState(false);
    const [failureCreation, setFailureCreation] = useState(false);
    const [vendorId, setVendorId] = useState("");
    const [vendorLedgerData, setVendorLedgerData] = useState([]);
    const [configInfo, setConfigInfo] = useState({});
    const [mixPanelData, setMixPanelData] = useState({});
    const [viewReportDialog,setViewReportDialog] = useState(false);
    const [passbookPdfOpen,setPassbookPdfOpen] = useState(false)
    const classes = useStyles();

    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let vendorIdValue = path[path.length - 1] ? path[path.length - 1] : "";

    let search = window.location.search;
    const params = queryString.parse(search);
    let orderId = params["order_id"];

    let dateFilterValues = getTripStartDateFilterValues();

    let history = useHistory();

    useEffect(() => {

        setVendorId(vendorIdValue);

        if (orderId) {
            dispatchGetPaymentStatus({
                orderId: orderId
            }, (response) => {
                if (response && response.status && response.status.code == 200) {
                    setPaySupplier(false);
                    if (response.response.message == "Transaction Failed.") {
                        handleFailureOpen();
                        setTimeout(() => {
                            handleFailureClose()
                        }, 3000);
                        trackDwebEvent('Dweb single supplier payout failed', {
                            vendor_id: vendorIdValue ? vendorIdValue : "",
                            vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                            // vendor_contact_number:, 
                            vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                            supplier_payout_amount: mixPanelData && mixPanelData.payoutAmount ? mixPanelData.payoutAmount : "",
                            count_of_trips: mixPanelData && mixPanelData.tripCount ? mixPanelData.tripCount : "",
                            bank_account_id: mixPanelData && mixPanelData.bankId ? mixPanelData.bankId : "",
                            failure_reason: response && response.response && response.response.message ? response.response.message : ""
                        });
                    } else {
                        handleSuccessOpen();
                        setTimeout(() => {
                            handleSuccessClose()
                        }, 3000);
                        trackDwebEvent('Dweb single supplier payout successful', {
                            vendor_id: vendorIdValue ? vendorIdValue : "",
                            vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                            // vendor_contact_number:, 
                            vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                            supplier_payout_amount: mixPanelData && mixPanelData.payoutAmount ? mixPanelData.payoutAmount : "",
                            count_of_trips: mixPanelData && mixPanelData.tripCount ? mixPanelData.tripCount : "",
                            bank_account_id: mixPanelData && mixPanelData.bankId ? mixPanelData.bankId : "",
                        });
                    }
                } else {
                    handleFailureOpen();
                    setTimeout(() => {
                        handleFailureClose()
                    }, 3000);
                    trackDwebEvent('Dweb single supplier payout failed', {
                        vendor_id: vendorIdValue ? vendorIdValue : "",
                        vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                        // vendor_contact_number:, 
                        vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                        supplier_payout_amount: mixPanelData && mixPanelData.payoutAmount ? mixPanelData.payoutAmount : "",
                        count_of_trips: mixPanelData && mixPanelData.tripCount ? mixPanelData.tripCount : "",
                        bank_account_id: mixPanelData && mixPanelData.bankId ? mixPanelData.bankId : "",
                        failure_reason: response && response.response && response.response.message ? response.response.message : ""
                    });
                }
            }, (response) => {
                handleFailureOpen();
                setTimeout(() => {
                    handleFailureClose();
                }, 3000);
                trackDwebEvent('Dweb single supplier payout failed', {
                    vendor_id: vendorIdValue ? vendorIdValue : "",
                    vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
                    // vendor_contact_number:, 
                    vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0,
                    supplier_payout_amount: mixPanelData && mixPanelData.payoutAmount ? mixPanelData.payoutAmount : "",
                    count_of_trips: mixPanelData && mixPanelData.tripCount ? mixPanelData.tripCount : "",
                    bank_account_id: mixPanelData && mixPanelData.bankId ? mixPanelData.bankId : "",
                    failure_reason: response && response.response && response.response.message ? response.response.message : ""
                });
            })
        }

    }, [
        dispatchGetSingleVendorLedger, orderId
    ]);

    useEffect(() => {
        setVendorLedgerData(user.singleVendorLedgerData);
    }, [user.singleVendorLedgerData]);

    useEffect(() => {

        if (user && user.configs && user.configs.online_payments_config) {
            setConfigInfo(user.configs.online_payments_config);
        } else {
            setConfigInfo({});
        }

    }, [user.configs]);

    const handleInfoOpen = () => {
        setInfoOpen(true);
    }

    const handleInfoClose = () => {
        setInfoOpen(false);
    }
    const handleSupplierPdf = () => {
        setViewReportDialog(true);
    }
    const handleViewReportClose = (val) => {
        setViewReportDialog(false);
        if(val && val == "trip"){
          setSupplierPdfOpen(true);
        }else if(val && val=="passbook"){
          setPassbookPdfOpen(true)
        }
    }
    const handleClosePdf = () => {
        setSupplierPdfOpen(false)
    }
    const handlePassbookClose = () => {
        setPassbookPdfOpen(false);
    }

    const handleSendMoney = () => {
        setPaySupplier(true);
    }

    const handlePaySupplierSideBarClose = (values) => {
        setPaySupplier(false);
        setMixPanelData(values);
    }

    const goToSingleSupplier = () => {


        // const currentUrl = (window.location.href).split("/");
        // const query = (currentUrl[currentUrl.length - 1]).split("?");
        // const vendorId = query[0];

        const currentUrl = history.location.pathname.split("/");
        const tabValue = currentUrl[currentUrl.length - 2];
        const query = (currentUrl[currentUrl.length - 1]).split("?");
        const vendorId = query[0];

        dispatchGetSingleVendorDetails(
            vendorId,
            (data) => {
                logger.log("Single Supplier Top Card Dweb", "Get Single Supplier Details Successfull");
                history.push({
                    pathname: `/suppliers/single-supplier/${tabValue}/${vendorId}`,
                    state: {
                        id: 8,
                        pageTitle: data && data.response && data.response.vendorName ? data.response.vendorName : "",
                        vendorId: vendorId
                    }
                });
            },
            () => {
                logger.log("Single Supplier Top Card Dweb", "Get Single Supplier Details Failed");
            }

        )

    }

    const handleSuccessOpen = () => {
        setSuccessCreation(true)
    }

    const handleSuccessClose = () => {
        setSuccessCreation(false)
        goToSingleSupplier()
    }

    const handleFailureOpen = () => {
        setFailureCreation(true)
    }

    const handleFailureClose = () => {
        setFailureCreation(false)
        goToSingleSupplier()
    }

    return (
        <>
            <Grid container justify="flex-start" direction="row" alignItems="center">
                <Grid item className={classes.sparklineContainer}>
                    <Grid container alignItems="center" >
                        <Grid item className={classes.sparklineTitle}>
                            Total&nbsp;Supplier&nbsp;Balance
                            <InfoOutlinedIcon onClick={handleInfoOpen} className={classes.infoCardIcon} />
                        </Grid>
                        <Grid item className={classes.loss} >
                            {numberFormat(user && user.singleVendorBalance ? user.singleVendorBalance : 0)}
                        </Grid>
                    </Grid>

                    <Grid item className={classes.gridButton}>
                        {user && user.singleVendorTotalTripCount != 0 &&
                            <div>
                                <Button fullWidth variant="contained" classes={{ root: classes.viewPDFCta }} onClick={() => { handleSupplierPdf() }}>
                                    <div className={classes.divAlign} >
                                        <PictureAsPdfIcon />
                                        <div className={classes.mlV3} >&nbsp;View PDF</div>
                                    </div>
                                </Button>
                            </div>
                        }
                        {/* {configInfo && configInfo.supplierPayout && configInfo.supplierPayout.show == 1 && user && user.singleVendorBalance != 0 &&
                            <div className={classes.mlV1} >
                                <Button fullWidth variant="contained" classes={{ root: classes.sendMoneyCta }} onClick={() => handleSendMoney()} >
                                    <div className={classes.divAlign}>
                                        <PaperPlaneIconWhite />
                                        <div className={classes.mlV3} >&nbsp;Send Money</div>
                                    </div>
                                </Button>
                            </div>
                        } */}
                    </Grid>

                </Grid>
            </Grid>

            {infoOpen && <InfoDialog confirmOpen={infoOpen} confirmTitle={"Supplier Balance"} confirmMessage={"The total balance amount to be paid for all the trips with this supplier in this period"} onClose={handleInfoClose} />}
            {
                supplierPdfOpen &&
                <ReportsDialog open={supplierPdfOpen} name={"Export Supplier Ledger Report"} fromSingleSupplierPage={true} vendorIdFromSingleSupplier={vendorIdValue} onClose={handleClosePdf} />
            }
            {viewReportDialog && <CardSelectionDialog open={viewReportDialog} title={"Select Report"} onClose={handleViewReportClose} />}
            {
                passbookPdfOpen &&
                <PassBookReportDialog open={passbookPdfOpen} name={"Export Supplier Passbook Report"} fromSingleSupplierPage={true} vendorIdFromSingleSupplier={vendorIdValue} onClose={handlePassbookClose} />
            }
            {
                paySupplier &&
                <PaySupplierSideBar rightSideBarOpen={paySupplier} toggleRightSideBar={handlePaySupplierSideBarClose} siderName={"pay-supplier"} calledFromFlow={"singleSupplier"} />
            }
            {successCreation && <SuccessDialog open={successCreation} title={"Payment Successful"} onClose={handleSuccessClose} />}
            {failureCreation && <FailureDialog open={failureCreation} title={"Payment Failed"} onClose={handleFailureClose} />}
        </>
    );
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetPaymentStatus: (data, onSuccess, onError) => {
        dispatch(getPaymentStatus(data, onSuccess, onError))
    },
    dispatchFetchSupplierTransact: (transactData, onSuccess, onFailure) => {
        dispatch(fetchSupplierTransactionLog(transactData, onSuccess, onFailure))
    },
    dispatchGetSingleVendorLedger: (data, onSuccess, onFailure) => {
        dispatch(getSingleVendorLedgerData(data, onSuccess, onFailure))
    },
    dispatchGetSingleVendorDetails: (id, onSuccess, onFailure) => {
        dispatch(singleVendorDetails(id, onSuccess, onFailure))
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleSupplierTopCard);